module.exports = __webpack_public_path__ + "media/images/riders/small/ELEONORA_FARINA-3cc61006048f4e992633e376e51d88f3.png";